import { useRef, useState } from "react";
import { Upload, X, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, API } from "@/lib/api";

export const FileUploader = ({ files, onChange }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (list) => {
    setBusy(true);
    for (const f of list) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const { data } = await api.post("/files", fd, { headers: { "Content-Type": "multipart/form-data" } });
        onChange((prev) => [...prev, data]);
      } catch (e) { toast.error(`${f.name}: ${errMsg(e)}`); }
    }
    setBusy(false);
  };

  return (
    <div>
      <div data-testid="file-dropzone" onClick={() => ref.current.click()}
        onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); upload([...e.dataTransfer.files]); }}
        className="cursor-pointer rounded-lg border border-dashed border-border hover:border-amber-400 transition-colors p-5 text-center text-sm text-muted-foreground">
        <Upload className="h-5 w-5 mx-auto mb-2 text-amber-400" />
        {busy ? "Wysyłanie…" : "Przeciągnij lub kliknij, aby dodać wizualizację / logo (JPG, PNG, PDF, max 15 MB)"}
        <input ref={ref} data-testid="file-input" type="file" multiple accept=".jpg,.jpeg,.png,.pdf" className="hidden" onChange={(e) => upload([...e.target.files])} />
      </div>
      {files.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3" data-testid="file-list">
          {files.map((f) => (
            <div key={f.id} className="relative flex items-center gap-2 rounded-md border border-border bg-secondary pl-2 pr-8 py-1.5 text-xs">
              {f.content_type === "application/pdf" ? <FileText className="h-6 w-6 text-rose-400" /> : <img src={`${API}/files/${f.id}`} alt="" className="h-8 w-8 rounded object-cover" />}
              <span className="max-w-[160px] truncate">{f.filename}</span>
              <button data-testid={`file-remove-${f.id}`} onClick={() => onChange((p) => p.filter((x) => x.id !== f.id))} className="absolute right-1.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-rose-400"><X className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
